import { render, staticRenderFns } from "./m_login.vue?vue&type=template&id=2c8b4a5e&scoped=true&"
import script from "./m_login.vue?vue&type=script&lang=js&"
export * from "./m_login.vue?vue&type=script&lang=js&"
import style0 from "./m_login.vue?vue&type=style&index=0&id=2c8b4a5e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8b4a5e",
  null
  
)

export default component.exports